import React from "react";

// Material UI
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

// Styles
import { textStyles } from "Common/Styles";
import { terracotta } from "Constants/ColourConstants";

// Translation
import { useTranslation } from "react-i18next";

// Utils
import { highlightWord } from "Utils/Reasons";

const RadioButtonsPreview = ({ reasons, language, label }) => {
  const { t } = useTranslation();
  const highlightWords =
    t("highlightWords.words", { lng: language, returnObjects: true }) || [];

  return (
    <Box sx={{ width: "50%" }}>
      <Typography sx={textStyles.infoText}>{label}</Typography>
      <RadioGroup>
        {(reasons || []).map((reason, idx) => (
          <FormControlLabel
            key={`${language}-${idx}`}
            value={reason[language]}
            control={<Radio sx={{ "&.Mui-checked": { color: terracotta } }} />}
            label={
              highlightWord(reason[language], highlightWords) ||
              (language === "en" ? "(Empty Reason)" : "(Raison vide)")
            }
            sx={{
              alignItems: "center",
              ".MuiFormControlLabel-label": {
                textAlign: "left",
                width: "100%",
              },
            }}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default RadioButtonsPreview;
